import api from './api';

// Serviço para gerenciar usuários
export const usuarioService = {
  // Listar usuários com paginação e filtros
  async list(params = {}) {
    try {
      const response = await api.get('/usuarios', { params });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao buscar usuários');
    }
  },

  // Buscar usuário por ID
  async getById(id) {
    try {
      const response = await api.get(`/usuarios/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao buscar usuário');
    }
  },

  // Criar usuário
  async create(userData) {
    try {
      const response = await api.post('/auth/register', userData);
      return response.data;
    } catch (error) {
      // Se tem erros de validação, formatar mensagem amigável
      const validationErrors = error.response?.data?.validationErrors;
      if (validationErrors && Array.isArray(validationErrors)) {
        const messages = validationErrors.map(err => err.msg).join('; ');
        throw new Error(messages);
      }
      throw new Error(error.response?.data?.message || 'Erro ao criar usuário');
    }
  },

  // Atualizar usuário
  async update(id, userData) {
    try {
      const response = await api.put(`/usuarios/${id}`, userData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao atualizar usuário');
    }
  },

  // Deletar usuário (soft delete)
  async delete(id) {
    try {
      const response = await api.delete(`/usuarios/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao excluir usuário');
    }
  },

  // Alterar status do usuário
  async changeStatus(id, ativo) {
    try {
      const response = await api.patch(`/usuarios/${id}/status`, { ativo });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao alterar status do usuário');
    }
  },

  // Resetar senha do usuário (versão antiga - gera senha aleatória)
  async resetPassword(id) {
    try {
      const response = await api.post(`/usuarios/${id}/reset-password`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao resetar senha');
    }
  },

  // Resetar senha do usuário (nova versão - gera senha padrão e força troca)
  async resetarSenha(id) {
    try {
      const response = await api.post(`/usuarios/${id}/resetar-senha`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || error.response?.data?.message || 'Erro ao resetar senha');
    }
  },

  // Desbloquear conta de usuário
  async desbloquear(id) {
    try {
      const response = await api.post(`/usuarios/${id}/desbloquear`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || error.response?.data?.message || 'Erro ao desbloquear usuário');
    }
  },

  // Verificar status de bloqueio do usuário
  async getStatusBloqueio(id) {
    try {
      const response = await api.get(`/usuarios/${id}/status-bloqueio`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || error.response?.data?.message || 'Erro ao verificar status de bloqueio');
    }
  },

  // Buscar estatísticas de usuários
  async getStats() {
    try {
      const response = await api.get('/usuarios/stats');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao buscar estatísticas');
    }
  },

  // Listar TODOS usuários ativos para uso em dropdowns/selects (sem paginação)
  async listForSelect() {
    try {
      const response = await api.get('/usuarios/select');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao buscar usuários');
    }
  }
};

export default usuarioService;
